import Card from '../ui/Card'
import { MdNearbyError } from "react-icons/md"

interface PageErrorBoundaryProps {
    className?: string
    resetErrorBoundary: () => void
    sentryEventId?: string
}

const PageErrorBoundary = ({ className, resetErrorBoundary, sentryEventId }: PageErrorBoundaryProps) => {
    return (
        <div className={`min-h-screen flex justify-center items-center bg-slate-50 ${className}`}>
            <Card className="py-10 px-3 md:px-5 mx-auto text-center w-full max-w-md">
                <MdNearbyError className="mx-auto mb-3 text-[80px] text-[#FF6600]" />
                <p className="text-[#167b91] mb-1 text-center text-2xl font-semibold">
                    Something went wrong
                </p>
                <p className="text-slate-600 font-medium mb-4">
                    We weren't able to load this page. Please try reloading the page or return to the home page.
                </p>

                {sentryEventId && (
                    <div className="mb-4 p-3 bg-slate-100 border border-slate-200 rounded-lg">
                        <p className="text-sm text-slate-600 break-words">
                            Error ID: <span className="font-mono font-semibold break-all">{sentryEventId}</span>
                        </p>
                    </div>
                )}

                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                    <button
                        onClick={resetErrorBoundary}
                        className="text-white bg-slate-900 text-lg font-medium rounded-full px-8 py-2.5 shadow-sm border-2 border-slate-900"
                    >
                        Reload page
                    </button>
                    <button
                        onClick={() => (window.location.href = '/')}
                        className="text-slate-900 text-lg font-medium rounded-full px-8 py-2.5 shadow-sm border-2 border-slate-300"
                    >
                        Home page
                    </button>
                </div>
            </Card>
        </div>
    )
}

export default PageErrorBoundary